'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageKeyInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageKeyInvariant = exports.messageKeyInvariant = function messageKeyInvariant(messageKey) {
  return (0, _invariant2.default)(typeof messageKey === 'string', 'Expected messageKey to be a `String` not a `%s`', typeof messageKey === 'undefined' ? 'undefined' : _typeof(messageKey));
};